import { render } from "./VocabularyList.vue?vue&type=template&id=ae748f4c&scoped=true&ts=true"
import script from "./VocabularyList.vue?vue&type=script&lang=ts"
export * from "./VocabularyList.vue?vue&type=script&lang=ts"

import "./VocabularyList.vue?vue&type=style&index=0&id=ae748f4c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae748f4c"]])

export default __exports__